import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Translations',
  basePath: '/translations',
  columns: [
    { key: 'language_title', label: 'Language', sortable: true },
    { key: 'var_title', label: 'Title', sortable: true },
    { key: 'translation', label: 'Translation', sortable: true },
  ],
  fields: [
    { key: 'country', label: 'Language', type: 'async-select',
      optionsUrl: '/countries/options',
      placeholder: 'Select language', required: true },
    { key: 'var_id', label: 'Title', type: 'async-select',
      optionsUrl: '/translation-vars/options',
      dependsOn: ['country'],
      valuesParams: { country: 'country' },
      visible: (v) => !!v.country,
      placeholder: 'Select translation title' },
    { key: 'translation', label: 'Translation', type: 'textarea',
      dependsOn: ['country'],
      visible: (v) => !!v.country },
  ],
  filters: [
    { key: 'country', label: 'Language', type: 'select',
      optionsUrl: '/countries/options' },
  ],
  defaultSort: { field: 'language_title', dir: 'asc' },
});
